import { render, staticRenderFns } from "./FormGroupBox.vue?vue&type=template&id=61162a3a&scoped=true&"
import script from "./FormGroupBox.vue?vue&type=script&lang=js&"
export * from "./FormGroupBox.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupBox.vue?vue&type=style&index=0&id=61162a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61162a3a",
  null
  
)

export default component.exports